import { DocumentPossessionIndicator, DocumentStatusEnum } from '../../../shared/constants/document';
import { getReadableDocumentStatus } from '../../document-wizard/utils/document-wizard.utils';
import { TemplateType } from '../../../consts/forms-types';
import { DocumentTemplateType } from '../../../shared/templateType';

export const getDocumentStatusIndicator = (
  documentStatus: DocumentStatusEnum | string | DocumentTemplateType,
  hasCurrentTeamPossession: boolean
) => {
  const possessionIndicator = hasCurrentTeamPossession
    ? DocumentPossessionIndicator.INTERNAL
    : DocumentPossessionIndicator.EXTERNAL;

  const isDocumentStatusReviewing = documentStatus === DocumentStatusEnum.REVIEWING;
  const templateType = documentStatus === TemplateType.CLAUSE ? TemplateType.CLAUSE : documentStatus;
  const status = getReadableDocumentStatus(templateType);

  return isDocumentStatusReviewing ? `${status} ${possessionIndicator}` : `${status}`;
};
